import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.dark,
  color: theme.palette.common.fogWhite,
  '& .RTVSectionSpacing': {
    padding: theme.spacing(6, 0),
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(4, 0),
    },
  },
  '& .MuiSkeleton-root': {
    backgroundColor: theme.palette.grey[400],
  },
  '& .RTVContainer': {
    padding: theme.spacing(0),
    [theme.breakpoints.down('xxl')]: {
      padding: theme.spacing(0, 6),
    },
    [theme.breakpoints.down('xl')]: {
      padding: theme.spacing(0, 3),
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 2),
    },
  },
  '& .RTVSectionTitle': {
    fontSize: theme.typography.pxToRem(32),
    textTransform: 'uppercase',
    marginBottom: theme.spacing(3),
    textAlign: 'center',
    '& .RTVOrange': {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(24),
    },
  },
  '& .HIWSSTitle, & .MFAQSTitle': {
    margin: '0 auto',
  },
}));

export default StyledBox;
